// Angular
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
// State
import { AppState } from '../state/app.state';
// Model
import { AppStateModel } from '../model/app.state.model';
// Service
import { AppInformationService } from './app-info.service';
// Other
import { Observable } from 'rxjs';

interface ILoggerService {
	info(value: any, ...rest: any[]): void;

	log(value: any, ...rest: any[]): void;

	warn(value: any, ...rest: any[]): void;

	error(value: any, ...rest: any[]): void;
}

/**
 * Logger Service to being able to use under Dev/Test
 */
@Injectable({
	providedIn: 'root'
})
export class LoggerService implements ILoggerService {
	app$:Observable<AppStateModel> = this.store.select(AppState.getAppState);
	private isConsoleEnable = false;

	constructor(
		private appInfo: AppInformationService,
		private store: Store
	) {
	}

	/**
	 * Enable the console based on the Configuration on Demand
	 */
	public enableConsole(): void {
		const appStateModel: AppStateModel = this.store.selectSnapshot(AppState.getAppState);
		if (appStateModel) {
			const appVersion = this.appInfo.appName ? appStateModel[this.appInfo.appName].version : null;
			this.isConsoleEnable = (appVersion && appVersion !== null && ['sandbox', 'develop', 'test', 'uat'].indexOf(appVersion.environment) > -1);
		}
	}

	/**
	 * Console LOG
	 * @param value
	 * @param params
	 */
	public info(value: any, ...params: any[]): void {
		if (this.isConsoleEnable) {
			// tslint:disable-next-line:no-console
			console.log(value, params);
		}
	}

	/**
	 * Console LOG
	 * @param value
	 * @param params
	 */
	public log(value: any, ...params: any[]): void {
		if (this.isConsoleEnable) {
			// tslint:disable-next-line:no-console
			console.log(value, params);
		}
	}

	/**
	 * Console WARN
	 * @param value
	 * @param params
	 */
	public warn(value: any, ...params: any[]): void {
		if (this.isConsoleEnable) {
			// tslint:disable-next-line:no-console
			console.warn(value, params);
		}
	}

	/**
	 * Console ERROR
	 * @param value
	 * @param params
	 */
	public error(value: any, ...params: any[]): void {
		if (this.isConsoleEnable) {
			// tslint:disable-next-line:no-console
			console.error(value, params);
		}
	}

}
